import { environment } from '../../environments/environment';
import { AppConfig } from '../app.config';

/**
 * Chapter (the customer's "my ceremony" portal) for this tenant.
 *
 * Staging is the shared Chapter staging host keyed by client slug + parent
 * company. Production is the shared Chapter production host (the same one the
 * Norfolk app uses); the Solihull route on it answered 200 on 2026-09-29. The
 * old myceremony.bookinglab.co.uk host that solihull.gov.uk still links now
 * redirects there.
 */
export function chapterLoginUrl(): string {
	const client = AppConfig.settings.env.customer_name;
	const company = AppConfig.settings.core.company_id;
	const host = environment.production
		? 'https://chapter.registrars.bookinglab.co.uk'
		: 'https://chapter.registrars.staging.bookinglab.co.uk';
	return `${host}/${client}/${company}/access`;
}
